// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lntegralRecord .el-form-item {\n  margin-right: 10px;\n}\n.lntegralRecord .cell {\n  text-align: center;\n}\n.lntegralRecord .lntegralRecord-table {\n  margin-bottom: 20px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
